import cn from "clsx";

export const ComparableDetailSection = ({
  children,
  title,
  dataTestId,
}: {
  children: React.ReactNode;
  title?: string;
  dataTestId?: string;
}) => {
  return (
    <div
      className={cn("relative", "w-full", "flex", "flex-col", "items-start", "justify-between", "gap-y-2")}
      data-testid={dataTestId}
      aria-label={title}
    >
      {title && (
        <div
          className={cn(
            "cid-price-section-title",
            "flex",
            "flex-row",
            "items-between",
            "justify-center",
            "text-sm",
            "font-medium",
            "text-blue-grey-950"
          )}
        >
          {title}
        </div>
      )}
      {children}
    </div>
  );
};
